import { render, staticRenderFns } from "./Banners.vue?vue&type=template&id=2966f0f9&lang=pug"
import script from "./Banners.vue?vue&type=script&lang=js"
export * from "./Banners.vue?vue&type=script&lang=js"
import style0 from "./Banners.vue?vue&type=style&index=0&id=2966f0f9&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports